import Toastify from 'toastify-js';
import 'toastify-js/src/toastify.css';

/**
 * showToast(text, type, duration)
 *
 * @param {string} text     - Message to display
 * @param {'success'|'error'|'info'|'warning'} type - Visual style (default: 'success')
 * @param {number} duration - Duration in ms (default: 3000)
 *
 * Usage:
 *   import { showToast } from '@/scripts/helpers/toast_helpers.js';
 *   showToast('Flash Successful');
 *   showToast('Something went wrong', 'error');
 *   showToast('Your data has been cleared.', 'success', 4000);
 */

const TOAST_STYLES = {
  success: {
    background: 'rgba(29, 185, 84, 0.15)',
    border: '1px solid rgba(29, 185, 84, 0.4)',
    borderLeft: '4px solid #1db954',
    boxShadow: '0 8px 32px rgba(29, 185, 84, 0.15), 0 4px 16px rgba(0,0,0,0.2)',
  },
  error: {
    background: 'rgba(220, 53, 69, 0.15)',
    border: '1px solid rgba(220, 53, 69, 0.4)',
    borderLeft: '4px solid #dc3545',
    boxShadow: '0 8px 32px rgba(220, 53, 69, 0.15), 0 4px 16px rgba(0,0,0,0.2)',
  },
  warning: {
    background: 'rgba(255, 165, 0, 0.15)',
    border: '1px solid rgba(255, 165, 0, 0.4)',
    borderLeft: '4px solid #ffa500',
    boxShadow: '0 8px 32px rgba(255, 165, 0, 0.15), 0 4px 16px rgba(0,0,0,0.2)',
  },
  info: {
    background: 'rgba(0, 123, 255, 0.15)',
    border: '1px solid rgba(0, 123, 255, 0.4)',
    borderLeft: '4px solid #007bff',
    boxShadow: '0 8px 32px rgba(0, 123, 255, 0.15), 0 4px 16px rgba(0,0,0,0.2)',
  },
};

export function showToast(text, type = 'success', duration = 3000) {
  const typeStyle = TOAST_STYLES[type] ?? TOAST_STYLES.success;

  Toastify({
    text,
    duration,
    close: true,
    gravity: 'top',
    position: 'right',
    stopOnFocus: true,
    style: {
      ...typeStyle,
      backdropFilter: 'blur(12px)',
      borderRadius: '16px',
      color: '#ffffff',
      fontWeight: '600',
      fontFamily: 'Inter, Arial, sans-serif',
      fontSize: '15px',
      padding: '14px 22px',
    },
  }).showToast();
}